/**
 * Deterministic random numbers with explicit state.
 *
 * Every function takes an RngState and returns a new one alongside its
 * result. Nothing here touches Math.random (ESLint forbids it in this package).
 * Same seed + same sequence of calls = same numbers, on every platform.
 */
/** xmur3 string hash → 32-bit seed. */
function hashSeed(seed) {
    let h = 1779033703 ^ seed.length;
    for (let i = 0; i < seed.length; i++) {
        h = Math.imul(h ^ seed.charCodeAt(i), 3432918353);
        h = (h << 13) | (h >>> 19);
    }
    h = Math.imul(h ^ (h >>> 16), 2246822507);
    h = Math.imul(h ^ (h >>> 13), 3266489909);
    return (h ^ (h >>> 16)) >>> 0;
}
export function seedRng(seed) {
    return { a: hashSeed(seed) };
}
/** mulberry32 step. Returns a float in [0, 1) and the next state. */
export function nextFloat(rng) {
    let a = (rng.a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    const value = ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    a = a >>> 0;
    return [value, { a }];
}
/** Integer in [0, n). n must be ≥ 1. */
export function nextInt(rng, n) {
    if (!Number.isInteger(n) || n < 1)
        throw new Error(`nextInt: n must be a positive integer, got ${n}`);
    const [f, next] = nextFloat(rng);
    return [Math.floor(f * n), next];
}
/** Fisher–Yates. Returns a new array; the input is not modified. */
export function shuffle(rng, items) {
    const out = items.slice();
    let state = rng;
    for (let i = out.length - 1; i > 0; i--) {
        const [j, next] = nextInt(state, i + 1);
        state = next;
        const tmp = out[i];
        out[i] = out[j];
        out[j] = tmp;
    }
    return [out, state];
}
//# sourceMappingURL=rng.js.map